module.exports = __webpack_public_path__ + "static/assets/940eaee5fce37aa61ba5e6845c71d766.png";